import { render, staticRenderFns } from "./SubirHerramientaModal.vue?vue&type=template&id=298b404a&scoped=true"
import script from "./SubirHerramientaModal.vue?vue&type=script&lang=js"
export * from "./SubirHerramientaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b404a",
  null
  
)

export default component.exports